import type { HTMLAttributes } from 'react';
import React, { useRef } from 'react';
import { twMerge } from 'tailwind-merge';

export const PlanChargesContainer: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <div
      ref={ref}
      className={twMerge('bg-white border-line rounded-0md border px-8 pt-1', className)}
      {...props}
    >
      {children}
    </div>
  );
};
